import { render, staticRenderFns } from "./TheoryRatingTranslation.vue?vue&type=template&id=77db9c5c"
import script from "./TheoryRatingTranslation.vue?vue&type=script&lang=js"
export * from "./TheoryRatingTranslation.vue?vue&type=script&lang=js"
import style0 from "./TheoryRatingTranslation.vue?vue&type=style&index=0&id=77db9c5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports